import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  OverdraftQuarterlyReviewAccount,
  OverdraftQuarterlyReviewAccountFilters,
  OverdraftQuarterlyReviewAccountSortType,
  OverdraftQuarterlyReviewStatus,
  PaginablePayloadApiResponse,
  PayloadApiResponse,
  RetryOverdraftQuarterlyReviewAccountBody,
  RetryOverdraftQuarterlyReviewAccountResult,
  RetryOverdraftQuarterlyReviewBody,
  RetryOverdraftQuarterlyReviewResult,
} from '@portal-workspace/grow-shared-library';
import { httpOptions, paginationUrl, toPaginationInfo } from '@portal-workspace/grow-ui-library';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const API_PREFIX = `${environment.api2Host}/api2`;

@Injectable()
export class OverdraftQuarterlyReviewService {
  constructor(private httpClient: HttpClient) {}

  getRuns(
    limit = 50,
    offset = 0,
  ): Observable<PaginablePayloadApiResponse<OverdraftQuarterlyReviewStatus>> {
    const url = paginationUrl(`${API_PREFIX}/get-overdraft-quarterly-review-runs`, {
      limit,
      offset,
      start: limit * offset,
      filter: null,
      sorts: null,
    });
    return this.httpClient.get<PaginablePayloadApiResponse<OverdraftQuarterlyReviewStatus>>(
      url,
      httpOptions(),
    );
  }

  getAccounts(options: {
    year: number;
    quarter: number;
    page: { limit: number; offset: number };
    filters: OverdraftQuarterlyReviewAccountFilters;
    sorts: OverdraftQuarterlyReviewAccountSortType;
  }): Observable<PaginablePayloadApiResponse<OverdraftQuarterlyReviewAccount>> {
    const pagination = toPaginationInfo({
      page: options.page,
      filter: '',
      sorts: options.sorts,
    });
    const params = new URLSearchParams({
      year: String(options.year),
      quarter: String(options.quarter),
    });
    if (options.filters.status) params.set('status', options.filters.status);
    if (options.filters.pismoAccountId) {
      params.set('pismoAccountId', String(options.filters.pismoAccountId));
    }
    const baseUrl = paginationUrl(
      `${API_PREFIX}/get-overdraft-quarterly-review-accounts`,
      pagination,
    );
    return this.httpClient.get<PaginablePayloadApiResponse<OverdraftQuarterlyReviewAccount>>(
      `${baseUrl}&${params.toString()}`,
      httpOptions(),
    );
  }

  retryRun(
    body: RetryOverdraftQuarterlyReviewBody,
  ): Observable<PayloadApiResponse<RetryOverdraftQuarterlyReviewResult>> {
    return this.httpClient.post<PayloadApiResponse<RetryOverdraftQuarterlyReviewResult>>(
      `${API_PREFIX}/retry-overdraft-quarterly-review`,
      body,
      httpOptions(),
    );
  }

  retryAccount(
    body: RetryOverdraftQuarterlyReviewAccountBody,
  ): Observable<PayloadApiResponse<RetryOverdraftQuarterlyReviewAccountResult>> {
    return this.httpClient.post<PayloadApiResponse<RetryOverdraftQuarterlyReviewAccountResult>>(
      `${API_PREFIX}/retry-overdraft-quarterly-review-account`,
      body,
      httpOptions(),
    );
  }
}
